import _ from 'lodash';
import { useMemo } from 'react';
import { EcoRoute } from 'types';
import useEcoRoutes from '../useEcoRoutes';

/**
 * This hooks will automatically retrive all the children of a route
 * 
 * @param path 
 * @returns 
 */
export const useRouteChildren = (path: string) => {
	const routes = useEcoRoutes();

	return useMemo(() => {
		let stack: Array<EcoRouteMapping> = _.cloneDeep(routes);
		const visited: string[] = [];
		let res: Array<EcoRouteMapping> = [];
		while (stack.length) {
			const node = stack.shift();

			if (!node) {
				break;
			}

			if (node.globalPath && node?.globalPath.includes(path)) {
				stack = [];
				if (node.children) {
					res = node.children;
				}
			} else {
				if (!visited.includes(node.path || '')) {
					visited.push(node.path || '');

					if (node.children) {
						node.children.forEach((item: EcoRouteMapping) => {
							item.globalPath = `${node.path}/${item.path}`.replace('//', '/')
						})
						stack = [...stack, ...node.children];
					}
				}
			}
		}
		return res;
	}, [path, routes]);
};

type EcoRouteMapping = EcoRoute & {
	globalPath?: string
	children?: Array<EcoRouteMapping>
}
